export const ACTION_TYPE = {
    GET_BOOKING_SERVICE_PRICING_NURSE: 'get_booking_service_pricing_nurse',
    GET_BOOKING_SERVICE_PRICING_PHYSIO: 'get_booking_service_pricing_physio',
    GET_BOOKING_SERVICE_PRICING_MEDICAL_ASSISTANT: 'get_booking_service_pricing_medical_assistant',
    GET_BOOKING_SERVICE_PRICING_CARE_AIDE: 'get_booking_service_pricing_care_aide'
}